import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Undo2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M9 14 4 9l5-5' }],
    ['path', { d: 'M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11' }],
  ],
];

export default Undo2;
